<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('editionCommande.generalTitle.achat')}}
      </p>
    </header>
    <div class="card-content">
      <information-msg-component title="general.info"
                                 :canClose="false"
                                 v-if="groupeProduitExistant || getAllLigneAPlat.length === 0"
                                 :libelleList="getMessage">
      </information-msg-component>
      <b-table :data="getAllLigneAPlat" :bordered="true" :striped="true"
               v-if="startArrayRendering && getAllLigneAPlat.length > 0">
        <b-table-column field="description" v-slot="props" cell-class="vertical-alignment"
                        :label="$t('editionCommande.achats.description')">
          <span v-html="props.row.description"></span>
        </b-table-column>
        <b-table-column field="totalHt"
                        v-slot="props" cell-class="vertical-alignment has-text-right"
                        :label="$t('editionCommande.achats.montantHt')">
          <div class="vertical-alignment">{{ props.row.totalHt | formatDevise }}</div>
        </b-table-column>
        <b-table-column field="fournisseur"
                        v-slot="props" cell-class="vertical-alignment"
                        :label="$t('editionCommande.achats.fournisseur')">
          <b-autocomplete
            :value="props.row.libelleFournisseur"
            :open-on-focus="false"
            :data="confreres"
            field="nomCommercial"
            :placeholder="$i18n.t('general.autocomplete.search')"
            @input="getConfrere($event, props.row)"
            :loading="isFetching"
            @select="setConfrere($event, props.row)">
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('general.autocomplete.noRslt')}}
              </div>
              <div v-else>
                {{$t('general.autocomplete.search')}}
              </div>
            </template>
          </b-autocomplete>
        </b-table-column>
        <b-table-column field="aFacturer"
                        v-slot="props" cell-class="vertical-alignment"
                        :label="$t('editionCommande.achats.aFacturer')"
                        v-if="!afficherModeReglement">
          <qd-switch v-model="props.row.aFacturer"
                    :disabled="echeancierWithLigneFacture(props.row)">
          </qd-switch>
        </b-table-column>
        <b-table-column field="modeReglement" v-slot="props" cell-class="vertical-alignment"
                        :label="$t('editionCommande.achats.modeReglement')"
                        v-else>
          <b-select v-model="props.row.modeReglementId" expanded>
            <option></option>
            <option v-for="modeReglement in modesReglement"
                    :key="modeReglement.id"
                    :value="modeReglement.id">
              {{modeReglement.libelle}}
            </option>
          </b-select>
        </b-table-column>
        <b-table-column field="dateReglement" v-slot="props"  cell-class="vertical-alignement"
                        :label="$t('editionCommande.achats.dateReglement')"
                        v-if="afficherModeReglement">
          <b-datepicker
            show-week-number
            icon="calendar-today"
            v-model="props.row.dateReglement"
            :nearby-selectable-month-days="true"
            position="is-bottom-left"
            editable>
          </b-datepicker>
        </b-table-column>
      </b-table>
    </div>
  </div>
</template>

<script>
import getDescriptionOfDetailLigne from '@/services/devisCommandes/getDescriptionOfDetailLigne';
import getLigneAPlat from '@/services/dcf/lignesDCF/getLigneAPlat';
import debounce from 'lodash/debounce';
import getAllConfrere from '@/services/tiers/getAllConfrere';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import informationMsgComponent from '@/components/general/informationMsgComponent';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import gestionDateBase from '@/services/general/gestionDateBase';
import * as devisConf from '@/configuration/devisConf';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'editionAchatDevisCommande',
  props: {
    devisCommande: {
      required: true,
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      startArrayRendering: false,
      confreres: [],
      isFetching: false,
      constantes: {
        AUCUN,
      },
    };
  },
  components: {
    informationMsgComponent,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    echeancierWithLigneFacture(ligne) {
      const echeancier = this.devisCommande.echeanciers.find((ech) => {
        return ech.referenceEcheancier === ligne.referenceEcheancier;
      });
      return echeancier.echeancierLignes.some((echLigne) => { return echLigne.facturationFaite; });
    },
    getConfrere: debounce(async function confrereData(text, ligneEnfant) {
      if (text === ligneEnfant.libelleFournisseur) return;
      try {
        ligneEnfant.libelleFournisseur = text;
        ligneEnfant.fournisseurId = null;
        if (!ligneEnfant.fournisseur) ligneEnfant.fournisseur = {};
        ligneEnfant.fournisseur.nomCommercial = null;
        this.confreres = await getAllConfrere({
          societeId: this.societeActiveId,
          nomCommercial: text,
        });
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      }
    }),
    setConfrere(newConfrere, ligneEnfant) {
      if (!newConfrere) return;
      if (!ligneEnfant.fournisseur) ligneEnfant.fournisseur = {};
      ligneEnfant.fournisseur.nomCommercial = newConfrere.nomCommercial;
      ligneEnfant.fournisseurId = newConfrere.id;
      ligneEnfant.libelleFournisseur = newConfrere.nomCommercial;
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getAllLigneAPlat() {
      return getLigneAPlat(this.devisCommande.lignesCommande.filter((ligne) => {
        return !ligne.referencePersonnalise;
      }));
    },
    groupeProduitExistant() {
      return this.devisCommande.lignesCommande.some((ligneCommande) => {
        return ligneCommande.referencePersonnalise !== null;
      });
    },
    getMessage() {
      const message = [];
      if (this.groupeProduitExistant) {
        message.push({ libelle: this.$t('editionCommande.achats.message') });
      }
      if (this.getAllLigneAPlat.length === 0) {
        message.push({ libelle: this.$t('editionCommande.achats.messageNoLigne') });
      }
      return message;
    },
    modesReglement() {
      return this.parametre(PARAMETRES_KEYS.modeReglement);
    },
    afficherModeReglement() {
      return this.devisCommande.type === devisConf.TYPE_FACTURE
        && this.devisCommande.sens === devisConf.SENS_VENTE;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
      this.devisCommande.lignesCommande.forEach((lignesCommande) => {
        lignesCommande.dateReglement = gestionDateBase(lignesCommande.dateReglement);
        if (!lignesCommande.lignesCommande || lignesCommande.lignesCommande.length === 0) {
          lignesCommande.description = getDescriptionOfDetailLigne(
            null, lignesCommande, this.devisCommande.type, [], false,
          );
          lignesCommande.libelleFournisseur = lignesCommande.fournisseurId ? lignesCommande.fournisseur.nomCommercial : '';
          return;
        }
        let isFirstLigne = true;
        lignesCommande.lignesCommande.forEach((ligneEnfant) => {
          ligneEnfant.description = getDescriptionOfDetailLigne(
            ligneEnfant, lignesCommande, this.devisCommande.type, [], isFirstLigne,
          );
          isFirstLigne = false;
          ligneEnfant.description = ligneEnfant.description.replaceAll('<br>', ' ');
          ligneEnfant.libelleFournisseur = ligneEnfant.fournisseurId ? ligneEnfant.fournisseur.nomCommercial : '';
          ligneEnfant.dateReglement = gestionDateBase(ligneEnfant.dateReglement);
        });
      });
      this.startArrayRendering = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style lang="scss">
</style>
